import React from 'react'
import { ModalEditLayoutFields, FormikSetFieldValue } from '../../../../../types/types'
import SwitchCheckbox from '../../../../../Components/UI/SwitchCheckbox/SwitchCheckbox'

type DecorationSwitchProps = {
    value: ModalEditLayoutFields['_isDecoration']
    valuePlacement: ModalEditLayoutFields['placement']
    setFieldValue: FormikSetFieldValue<ModalEditLayoutFields>
}

const DecorationSwitch: React.FC<DecorationSwitchProps> = React.memo(({ value, valuePlacement, setFieldValue }) => {

    const handleChange = (e: React.ChangeEvent<HTMLInputElement> | undefined) => {
        const target = e?.target
        if (target) {
            setFieldValue('_isDecoration', target.checked)
            setFieldValue('layoutType', null)
        }
    }

    if (!!valuePlacement?.layout_temp) {
        return (
            <SwitchCheckbox
                text='Оформление клуба'
                checked={value}
                classes={['bf-edit-layout__decoration-switch']}
                onChange={handleChange}
            />
        )
    }
    return null
})

export default DecorationSwitch